module.exports = __webpack_public_path__ + "static/media/banner3.10fe65e5.png";